<div class="ach-form-border content mt-5">
  <h1 class="content mt-3">Account Direct Deposit Payment Account</h1>

  @if (!hasSetupACHRecord) {
    <h3 class="content medium-text">
      Set up your bank account to receive payments
    </h3>
  }

  @if (accountUpdated) {
    <h4 class="content account-updated">
      Account Updated
    </h4>
  }

  @if (hasSetupACHRecord) {
    <h3 class="content">
      Current Account, Edit Fields to Update to New Account
    </h3>
  }

  <p class="content">*Account Numbers must be 5-17 characters</p>

  <form [formGroup]="achRecordFormGroup" autocomplete="off" class="content">
    <div class="flec-row">
      <mat-form-field class="input mr-2 flex-0" appearance="outline">
        <mat-label>Bank Name</mat-label>

        <input type="text" maxlength="50" autocomplete="false" formControlName="bankName" matInput
          autocompleteOff />
        </mat-form-field>

        <mat-form-field class="input flex-0 mr-2" appearance="outline">
          <mat-label>Routing Number</mat-label>

          <input [type]="hideRoutingNumber ? 'password' : 'text'" formControlName="routingNumber"
            autocomplete="false" matInput minlength="9" maxlength="9" digitOnly autocompleteOff
            #routingNumber />

            <button mat-icon-button matSuffix (click)="hideRoutingNumber = !hideRoutingNumber"
              [attr.aria-label]="'Hide Routing Number'" [attr.aria-pressed]="hideRoutingNumber">
              <mat-icon>{{ hideRoutingNumber ? "visibility_off" : "visibility" }}</mat-icon>
            </button>

            <mat-hint align="end">{{ routingNumber.value.length }} / 9</mat-hint>
          </mat-form-field>

          <mat-form-field class="input flex-0" appearance="outline">
            <mat-label>Account Number</mat-label>

            <input [type]="hideAccountNumber ? 'password' : 'text'" formControlName="accountNumber" minlength="5"
              maxlength="17" autocomplete="false" matInput digitOnly autocompleteOff />

              <button mat-icon-button matSuffix (click)="hideAccountNumber = !hideAccountNumber"
                [attr.aria-label]="'Hide Account Number'" [attr.aria-pressed]="hideAccountNumber">
                <mat-icon>{{ hideAccountNumber ? "visibility_off" : "visibility" }}</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <button type="submit" [disabled]="achRecordFormGroup.invalid || achRecordFormGroup.pristine"
            (click)="submitACHRecord()" mat-flat-button color="primary" class="mt-2 mb-2 border-2 shade">
            Submit
          </button>

          @if (achRecordFormGroup.controls.bankName.hasError('required')) {
            <p class="error-message">
              *Bank Name is Required
            </p>
          }

          @if (achRecordFormGroup.controls.routingNumber.hasError('pattern') && achRecordFormGroup.controls.routingNumber.dirty) {
            <p class="error-message"
              >
              *Invalid Routing Number, Must be all numbers to submit
            </p>
          }

          @if (achRecordFormGroup.controls.accountNumber.hasError('pattern') && achRecordFormGroup.controls.accountNumber.dirty) {
            <p class="error-message"
              >
              *Invalid Account Number, Must be all numbers to submit
            </p>
          }

          @if (achRecordFormGroup.controls.routingNumber.hasError('required')) {
            <p class="error-message">
              *Routing Number is Required
            </p>
          }

          @if (achRecordFormGroup.controls.accountNumber.hasError('required')) {
            <p class="error-message">
              *Account Number is Required
            </p>
          }

          @if (achRecordFormGroup.controls.routingNumber.hasError('maxlength')) {
            <p class="error-message">
              *Routing Number must be 9 characters
            </p>
          }

          @if (achRecordFormGroup.controls.routingNumber.hasError('minlength')) {
            <p class="error-message">
              *Routing Number must be 9 characters
            </p>
          }

          @if (achRecordFormGroup.controls.accountNumber.hasError('maxlength')) {
            <p class="error-message">
              *Account Number must be between 5-17 characters
            </p>
          }

          @if (achRecordFormGroup.controls.accountNumber.hasError('minlength')) {
            <p class="error-message">
              *Account Number must be between 5-17 characters
            </p>
          }
        </form>
      </div>